<template>
  <div class="bg-brand-black min-h-screen flex lg:bg-white">
    <div class="flex-1 flex flex-col justify-center py-12 px-4 sm:px-6 lg:flex-none lg:px-20 xl:px-24">
      <div class="mx-auto h-12 w-auto my-6 lg:hidden">
        <img src="@/assets/brand/icon.svg" class="h-10 -mt-4 w-auto inline-block" alt="Logo" />
        <span class="text-white font-extrabold text-4xl ml-2 tracking-tight">Churnkey</span>
      </div>
      <div class="mx-auto w-full max-w-screen-sm lg:w-96 shadow-lg lg:shadow-none px-16 py-12 rounded-lg lg:p-0 bg-white">
        <h2 class="text-center text-2xl tracking-tight leading-9 font-extrabold text-gray-900">Forgot your Password <span class="ml-2">🔑</span></h2>
        <article class="mt-8" v-loading="pending">
          <div class="mt-4">
            <el-form label-position="top" label-width="100px" @submit.prevent.native="onSubmit">
              <el-form-item label="Email">
                <el-input placeholder="Email" type="email" v-model="email"></el-input>
              </el-form-item>
              <el-button native-type="submit" type="primary" class="w-full text-lg">Reset Password →</el-button>
              <div class="text-center mt-2">
                <el-button type="text" @click="goBack()">Return to Login</el-button>
              </div>
            </el-form>
          </div>
        </article>
      </div>
    </div>
    <div class="hidden lg:block relative w-0 flex-1 bg-brand-black">
      <div class="flex justify-center items-center flex-col h-full">
        <div class="absolute right-8 top-8">
          <p class="text-white font-semibold inline-block">Need an account?</p>
          <span class="inline-block">
            <a href="/login" class="text-brand-yellow hover:underline ml-2 font-bold">Sign up </a>
          </span>
        </div>
        <div class="h-1/3">
          <img src="@/assets/brand/icon.svg" class="h-full -mt-2 w-auto" alt="Logo" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserService from '@/api/user.service';

export default {
  name: 'Reset',
  data() {
    return {
      email: '',
    };
  },

  methods: {
    async onSubmit() {
      try {
        this.pending = true;
        await UserService.resetPassword({ email: this.email });
        this.$notify({ title: 'Check your email for instructions.', type: 'success' });
        this.$router.push('/login');
        this.pending = false;
      } catch (err) {
        this.pending = false;
      }
    },
    goBack() {
      this.$router.push('/login');
    },
  },
};
</script>
